<article [class.container]="is_accept_advertisement" class="box">
  <header class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{ 'NOTIFICATIONS_TAB.SETTINGS' | translate }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide('cancel')"
    ></button>
  </header>

  <div
    class="modal-body"
    #root
    [root]="root.nativeElement"
    (appDeferLoad)="onScroll()"
  >
    <section class="modal-body__item">
      <p class="section-title">
        {{ 'NOTIFICATIONS_TAB.CONSENT' | translate | uppercase }}
      </p>
      <div class="checkbox">
        <input
          type="checkbox"
          [id]="'consent'"
          [ngModel]="is_accept_advertisement"
          (ngModelChange)="changeConsentStatus($event)"
        />
        <label [for]="'consent'">
          <div class="checkbox__el"></div>
          <div class="checkbox__desc">
            <h3>{{ 'NOTIFICATIONS_TAB.ACCEPT_NOTIFICATIONS' | translate }}</h3>
          </div>
        </label>
      </div>
    </section>

    @if (is_accept_advertisement) {
      @if (errorTitle) {
        <div class="alert error alert-danger">
          <p>{{ errorTitle }}</p>
          <p>{{ errorText }}</p>
        </div>
      } @else {
        @if (!(isFirstLoading$ | async)) {
          @if ((notificationTopics$ | async)?.data; as topics) {
            <section class="modal-body__item">
              <p class="section-title">
                {{
                  'NOTIFICATIONS_TAB.NOTIFICATIONS_TOPICS'
                    | translate
                    | uppercase
                }}
              </p>
              <div class="topics-list">
                @for (topic of topics; track topic) {
                  <div
                    #element
                    class="checkbox"
                    (click)="$event.stopPropagation()"
                  >
                    <input
                      type="checkbox"
                      [disabled]="loadingTopicIds.has(topic.id)"
                      [id]="topic.id"
                      [ngModel]="topic.is_subscribe"
                      (ngModelChange)="changeTopicStatus(topic.id, $event)"
                    />
                    <label [for]="topic.id">
                      <div class="checkbox__el"></div>
                      <div class="checkbox__desc">
                        <h3>{{ topic.title }}</h3>
                      </div>
                    </label>
                  </div>
                }
              </div>
              @if (isInfinityScrollLoading$ | async) {
                <ng-container [ngTemplateOutlet]="smallSpinner"></ng-container>
              }
            </section>
          } @else {
            <div class="full-height item-placeholder text-center">
              <img src="./assets/img/misc/box.svg" alt="" class="eye-d-none" />
              <p class="text-secondary">
                {{ 'NOTIFICATIONS_TAB.NO_NOTIFICATIONS' | translate }}
              </p>
            </div>
          }
        } @else {
          <div class="full-height text-secondary text-center">
            <div class="spinner-border spinner-border-lg" role="status">
              <span class="sr-only">{{ 'LOADING' | translate }}</span>
            </div>
          </div>
        }
      }
    }
  </div>

  <ng-template #smallSpinner>
    <div class="text-secondary text-center">
      <div class="spinner-border spinner-border-md" role="status">
        <span class="sr-only">{{ 'LOADING' | translate }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template #spinner>
    <div class="full-height text-secondary text-center">
      <div class="spinner-border spinner-border-lg" role="status">
        <span class="sr-only">{{ 'LOADING' | translate }}</span>
      </div>
    </div>
  </ng-template>
</article>
